import ClientList from "../../../../Clients/components/client-listing/components/index";
import ProviderHeader from "../../provider-header/components/index";

const ProviderClientList = () => {
    return (
    <div>
        <ProviderHeader />
      <ClientList />
      
    </div>
  );
};

export default ProviderClientList;
